import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=76f70cec&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76f70cec')) {
      api.createRecord('76f70cec', component.options)
    } else {
      api.reload('76f70cec', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=76f70cec&", function () {
      api.rerender('76f70cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8IQY83S82DX3I/JS/pricehelp.vue"
export default component.exports